var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"js-flatpickr form-control flatpickr-custom",attrs:{"id":_vm.pickerId,"type":"text","placeholder":"Select date","disabled":_vm.disabled,"data-hs-flatpickr-options":_vm.options},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }